export const environment = {
  baseHref: window.location.pathname,
  production: false,
  name: 'int',
  baseUrl: window.location.origin,
  backendEndpoint: '/ppr/rest/'
};
